export default __webpack_public_path__ + "static/media/Abdomen.59033708.svg";